import React, { Component } from 'react'
import { injectIntl, intlShape } from 'react-intl'
import ReactMarkdown from 'react-markdown'

import NewsHeader from './NewsHeader'
import SocialSidebar from './SocialSidebar'

class News extends Component {
  constructor(props){
    super(props);
    this.state = {
      visible: this.props.visible,
    }
  }

  handleVisibility() {
    if(this.state.visible) {
      this.setState({
        visible: false
      })
    }
    else {
      this.setState({
        visible: true
      })
    }
  }

  render() {
    const release = this.props.release
    const visible = this.state.visible

    return (
      <article key={release.sys.id} className="release">
        <div className="container">
          <NewsHeader fields={release.fields} tagsVisible={visible} />
          {(visible && release.fields.image) && <img src={release.fields.image.fields.file.url+'?fm=jpg&q=80&w=970'} alt="" />}
          {visible &&
            <div>
              <SocialSidebar url={this.props.url} />
              <ReactMarkdown source={release.fields.content} softBreak="br" className="content" />
            </div>
          }
          {visible && <span className="toggle" onClick={this.handleVisibility.bind(this)}>&laquo;&nbsp;&nbsp;&nbsp;{this.props.intl.messages["general.showLess"]}</span>}
          {!visible && <span className="toggle" onClick={this.handleVisibility.bind(this)}>&raquo;&nbsp;&nbsp;&nbsp;{this.props.intl.messages["general.showMore"]}</span>}
        </div>
      </article>
    )
  }
}

News.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(News)


// WEBPACK FOOTER //
// ./src/components/News.js